import { ChangeEvent, MouseEvent } from "react";
import {
  Box,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Checkbox,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { ArrowDropUp, ArrowDropDown } from "@mui/icons-material";
import CheckboxChecked from "assets/CheckboxChecked";
import CheckboxUnchecked from "assets/CheckboxUnchecked";
import { useTheme } from "styled-components";

export interface IHeadCell {
  disablePadding: boolean;
  id: string;
  label: string;
  showColumnUnExpanded?: boolean;
  numeric?: false,
  isFilterable: boolean;
  isNotSortable?: boolean;
  isDate?: boolean;
}

interface MxdrDatagirdHeaderProps {
  numSelected: number;
  onRequestSort: (
    property: string | number | symbol
  ) => void;
  onSelectAllClick: (event: ChangeEvent<HTMLInputElement>) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
  onFilterClick: (event: MouseEvent<unknown>) => void;
  headCells: IHeadCell[];
  visibleKeys: string[],
  showSelectionCheckbox?: boolean;
}

export type Order = "asc" | "desc";

const DarkDatagridHeader = ({
  onSelectAllClick,
  order,
  orderBy,
  numSelected,
  rowCount,
  onRequestSort,
  onFilterClick,
  headCells,
  visibleKeys,
  showSelectionCheckbox,
}: MxdrDatagirdHeaderProps) => {

  const theme = useTheme();
  
  return (
    <TableHead>
      <TableRow>
        {showSelectionCheckbox && (
          <TableCell padding="checkbox">
            <Checkbox
              color="primary"
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              icon={<CheckboxUnchecked theme={theme}/>}
              checkedIcon={<CheckboxChecked />}
              indeterminateIcon={<CheckboxUnchecked theme={theme}/>}
            />
          </TableCell>
        )}
        {headCells.map((headCell) => (
          visibleKeys.includes(headCell.id) && (
            <TableCell
              key={headCell.id}
              align={"left"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              onClick={onFilterClick}
            >
              {headCell.isNotSortable ? (
                <>{headCell.id}</>
              ) : (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={() => onRequestSort(headCell.id)}
                  
                  hideSortIcon={orderBy !== headCell.id}
                  IconComponent={() =>
                    order === "desc" ? <ArrowDropUp /> : <ArrowDropDown />
                  }
                >
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </Box>
                  ) : null}
                </TableSortLabel>
              )}
            </TableCell>
          )
        ))}
      </TableRow>
    </TableHead>
  );
};

export default DarkDatagridHeader;
